/* eslint-disable camelcase */
import * as React from 'react';
import { useForm } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoadingButton } from '@mui/lab';
import { IconButton, InputAdornment, Stack, Link } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import swal from 'sweetalert';
import Button from '@mui/material/Button';
import {
  dropDownServiceMaster,
  getTrainingSubLessonDataForUpdate,
  subTrainingLessonUpdate,
} from '../../../common/api-service';

function EditTrainingSubLesson() {
  const navigate = useNavigate();
  const theme = useTheme();

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const subTrainingLesson_status = ['active', 'disabled'];

  function getStyles(pet_type, petName, theme) {
    return {
      fontWeight:
        petName.indexOf(pet_type) === -1 ? theme.typography.fontWeightRegular : theme.typography.fontWeightMedium,
    };
  }

  const [AdminNotes, setAdminNotes] = useState('');
  const [loading, setLoading] = useState(false);
  const [userName, setUserName] = useState('');
  const [subTrainingLessonStatus, setSubTrainingLessonStatus] = React.useState('');
  const [subTrainingLessonfieldCount, setSubTrainingLessonFieldCount] = useState([]);
  const [serviceMasterId, setServiceMaster] = React.useState('62f646cde874f755ae088610');
  const [idget, setIdget] = React.useState('');
  const [data, setData] = useState([]);

  const handleAdd = () => {
    const abc = [...subTrainingLessonfieldCount, []];
    setSubTrainingLessonFieldCount(abc);
  };

  const addNewhandleChange = (onChangevalue, i) => {
    const inputData = [...subTrainingLessonfieldCount];
    inputData[i] = onChangevalue.target.value;
    setSubTrainingLessonFieldCount(inputData);
  };

  const handleDelete = (i) => {
    const deleteVal = [...subTrainingLessonfieldCount];
    deleteVal.splice(i, 1);
    setSubTrainingLessonFieldCount(deleteVal);
  };

  const getSubTrainingLessonID = () => {
    const getSubLessonID = localStorage.getItem('getSubLessonID');
    setIdget(getSubLessonID);
    const payload = {
      _id: getSubLessonID,
    };

    return getTrainingSubLessonDataForUpdate(payload).then((res) => {
      if (res.data.status === true) {
        const data = res.data.data;
        setUserName(data.title);
        setSubTrainingLessonFieldCount(data.sub_titles);
        setAdminNotes(data.admin_notes);
        setServiceMaster(data.service_master_id);
        setSubTrainingLessonStatus(data.status);
      } else {
        console.log('error');
      }
    });
  };
  useEffect(() => {
    getSubTrainingLessonID();
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: 'all',
  });

  const onSubmit = () => {
    setLoading(true);
    const payload = {
      _id: idget,
      title: userName,
      sub_titles: subTrainingLessonfieldCount,
      admin_notes: AdminNotes,
      status: subTrainingLessonStatus,
    };
    return subTrainingLessonUpdate(payload).then(
      (res) => {
        if (res.data.status === true) {
          setLoading(false);

          swal({
            title: res.data.message,
            icon: 'success',
            timer: 2000,
            button: false,
          });
          navigate('/dashboard/trainingSubLesson', { replace: true });
        } else {
          swal({
            title: res.data.message,
            icon: 'success',
            timer: 2000,
            button: false,
          });
        }
      },
      (err) => {
        console.log('err', err);
      }
    );
  };

  return (
    <div>
      <Typography
        variant="h3"
        component="div"
        sx={{
          '& > :not(style)': { width: '25ch' },
        }}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        Update SubLesson
      </Typography>
      <Card>
        <CardContent>
          <Box component="form" minHeight="50vh" noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
            <Stack spacing={3}>
              <Grid container>
                <Grid item xs={12} sm={12}>
                  <Grid>
                    {/* Title */}
                    <TextField
                      id="outlined-basic"
                      label="Title"
                      variant="outlined"
                      value={userName}
                      name="title"
                      required
                      {...register('title', {
                        required: true,
                      })}
                      onChange={(e) => setUserName(e.target.value)}
                      style={{ width: '100%' }}
                    />
                    {errors.title && errors.title.type === 'required' && (
                      <p className="text-danger" style={{ color: 'red' }}>
                        *required
                      </p>
                    )}
                  </Grid>

                  {/* Sub Titles */}
                  <Grid>
                    <Button variant="contained" onClick={() => handleAdd()} sx={{ mb: 3 }}>
                      Add Sub Title
                    </Button>

                    {subTrainingLessonfieldCount.map((sub_titles, i) => {
                      return (
                        <Grid sx={{ mt: 3 }}>
                          <TextField
                            id="outlined-basic"
                            label="Sub Titles"
                            variant="outlined"
                            value={sub_titles}
                            onChange={(e) => {
                              addNewhandleChange(e, i);
                            }}
                            style={{ width: '100%' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Button
                                    aria-label="Delete"
                                    edge="end"
                                    color="error"
                                    variant="outlined"
                                    onClick={() => handleDelete(i)}
                                  >
                                    Delete
                                  </Button>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>
                      );
                    })}
                  </Grid>

                  {/* Admin Notes */}
                  <Grid sx={{ mt: 3 }}>
                    <TextField
                      id="outlined-basic"
                      label="Admin Notes"
                      variant="outlined"
                      value={AdminNotes}
                      onChange={(e) => setAdminNotes(e.target.value)}
                      style={{ width: '100%' }}
                    />
                  </Grid>

                  {/* Status */}
                  <Grid>
                    <FormControl sx={{ minWidth: '100%', mt: 3 }}>
                      <InputLabel id="demo-multiple-chip-label">Status</InputLabel>
                      <Select
                        labelId="demo-multiple-chip-label"
                        id="demo-multiple-chip"
                        // multiple
                        value={subTrainingLessonStatus}
                        onChange={(e) => {
                          setSubTrainingLessonStatus(e.target.value);
                        }}
                        input={<OutlinedInput id="select-multiple-chip" label="Status" />}
                        MenuProps={MenuProps}
                      >
                        {subTrainingLesson_status.map((subTrainingLesson_status) => (
                          <MenuItem
                            key={subTrainingLesson_status}
                            value={subTrainingLesson_status}
                            style={getStyles(subTrainingLesson_status, subTrainingLessonStatus, theme)}
                          >
                            {subTrainingLesson_status}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid sx={{ mt: 3 }}>
                    <Box component="span" m={1} display="flex" justifyContent="space-between" alignItems="center">
                      <LoadingButton variant="contained" type="submit">
                        Update Sub Lesson
                      </LoadingButton>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Stack>
          </Box>
        </CardContent>
      </Card>
    </div>
  );
}

export default EditTrainingSubLesson;
